import { Suspense } from 'react';
import { useEffect } from 'react';

import {
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
} from 'react-router-dom';

import AdminPanel from './screens/admin/AdminPanel';

import 'bootstrap/dist/css/bootstrap.min.css';

import PortalResourceListPage from './screens/admin/portalResource/PortalResourceListPage';
import PortalResourceEditPage from './screens/admin/portalResource/PortalResourceEditPage';
import PortalResourceCreatePage from './screens/admin/portalResource/PortalResourceCreatePage';

import AuthorListPage from './screens/admin/author/AuthorListPage';
import AuthorEditPage from './screens/admin/author/AuthorEditPage';
import AuthorCreatePage from './screens/admin/author/AuthorCreatePage';

import MediaUsageGoalListPage from './screens/admin/mediaUsageGoal/MediaUsageGoalListPage';
import MediaUsageGoalEditPage from './screens/admin/mediaUsageGoal/MediaUsageGoalEditPage';
import MediaUsageGoalCreatePage from './screens/admin/mediaUsageGoal/MediaUsageGoalCreatePage';

import ResourceTypeListPage from './screens/admin/resourceType/ResourceTypeListPage';
import ResourceTypeEditPage from './screens/admin/resourceType/ResourceTypeEditPage';
import ResourceTypeCreatePage from './screens/admin/resourceType/ResourceTypeCreatePage';

import SubjectMatterCategoryListPage from './screens/admin/subjectMatterCategory/SubjectMatterCategoryListPage';
import SubjectMatterCategoryEditPage from './screens/admin/subjectMatterCategory/SubjectMatterCategoryEditPage';
import SubjectMatterCategoryCreatePage from './screens/admin/subjectMatterCategory/SubjectMatterCategoryCreatePage';

import SchoolTypeListPage from './screens/admin/schoolType/SchoolTypeListPage';
import SchoolTypeEditPage from './screens/admin/schoolType/SchoolTypeEditPage';
import SchoolTypeCreatePage from './screens/admin/schoolType/SchoolTypeCreatePage';

import FAQItemListPage from './screens/admin/faq/FAQItemListPage';
import FAQItemEditPage from './screens/admin/faq/FAQItemEditPage';
import FAQItemCreatePage from './screens/admin/faq/FAQItemCreatePage';

import LoginPanel from './screens/admin/login/LoginPanel';
import ServerSettingsPanel from './screens/admin/serverSettings/ServerSettingsPanel';

import LoginStore from './stores/LoginStore';
import ServerSettingsStore from './stores/ServerSettingsStore';

import { HomepageDesktop } from './screens/HomepageDesktop';
import { DirectoryDesktop } from './screens/DirectoryDesktop';
import { SingleMaterial } from './screens/SingleMaterial';
import { DasProjektDesktop } from './screens/DasProjektDesktop';
import { FaqDesktop } from './screens/FaqDesktop';

import { ImpressumDesktop } from './screens/ImpressumDesktop';
import { DatenschutzerklaerungDesktop } from './screens/DatenschutzerklaerungDesktop';

import ScrollToTopLayout from './ScrollToTopLayout';

const TuecedeTransferPortalApp = () => {
    /*
	if(screen < 2000)
	versionToUse = Desk
	else 
	versionToUse = mobile
	*/

    const loginStore = LoginStore((state) => state);
    const serverSettingsStore = ServerSettingsStore((state) => state);

    useEffect(() => {
        serverSettingsStore.load();
        loginStore.checkIsLoggedIn();

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    let router = null;

    if (null == serverSettingsStore.serverSettings) {
        return null;
    } else {
        if (!loginStore.isLoggedIn) {
            router = createBrowserRouter(
                createRoutesFromElements(
                    <Route element={<ScrollToTopLayout />}>
                        <Route path="*">
                            <Route
                                index
                                element={
                                    <HomepageDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />
                            <Route
                                path="directory/"
                                element={
                                    <DirectoryDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                        showDates={
                                            serverSettingsStore.serverSettings
                                                .isDirectoryPageMaterialsCreationDateVisible
                                        }
                                    />
                                }
                            />
                            <Route
                                path="singleMaterial/:portalResourceId"
                                element={
                                    <SingleMaterial
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />
                            <Route
                                path="project/"
                                element={
                                    <DasProjektDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />
                            <Route
                                path="faq/"
                                element={
                                    <FaqDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />

							<Route
                                path="faq/:faqId"
                                element={
                                    <FaqDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />

                            <Route
                                path="login/"
                                element={
                                    <LoginPanel
                                        isLoggedIn={loginStore.isLoggedIn}
                                    />
                                }
                            />

                            <Route
                                path="impressum/"
                                element={
                                    <ImpressumDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />
                            <Route
                                path="datenschutz/"
                                element={
                                    <DatenschutzerklaerungDesktop
                                        shareFeedbackEmailAddress={
                                            serverSettingsStore.serverSettings
                                                .shareFeedbackEmailAddress
                                        }
                                    />
                                }
                            />
                            <Route path="*" element={<HomepageDesktop />} />
                        </Route>
                    </Route>,
                ),
            );
        } else {
            router = createBrowserRouter(
                createRoutesFromElements(
                    <Route path="*">
                        {/*<Route index element={<Navigate to="/admin" replace />} />*/}
                        <Route
                            index
                            element={
                                <HomepageDesktop
                                    shareFeedbackEmailAddress={
                                        serverSettingsStore.serverSettings
                                            .shareFeedbackEmailAddress
                                    }
                                />
                            }
                        />
                        <Route
                            path="directory/"
                            element={
                                <DirectoryDesktop
                                    shareFeedbackEmailAddress={
                                        serverSettingsStore.serverSettings
                                            .shareFeedbackEmailAddress
                                    }
                                />
                            }
                        />
                        <Route
                            path="singleMaterial/:portalResourceId"
                            element={
                                <SingleMaterial
                                    shareFeedbackEmailAddress={
                                        serverSettingsStore.serverSettings
                                            .shareFeedbackEmailAddress
                                    }
                                />
                            }
                        />
                        <Route
                            path="project/"
                            element={
                                <DasProjektDesktop
                                    shareFeedbackEmailAddress={
                                        serverSettingsStore.serverSettings
                                            .shareFeedbackEmailAddress
                                    }
                                />
                            }
                        />
                        <Route
                            path="faq/"
                            element={
                                <FaqDesktop
                                    shareFeedbackEmailAddress={
                                        serverSettingsStore.serverSettings
                                            .shareFeedbackEmailAddress
                                    }
                                />
                            }
                        />

                        <Route
                            path="login/"
                            element={
                                !loginStore.isLoggedIn ? (
                                    <LoginPanel
                                        isLoggedIn={loginStore.isLoggedIn}
                                    />
                                ) : (
                                    <AdminPanel />
                                )
                            }
                        />

                        <Route path="admin/" element={<AdminPanel />} />
                        <Route
                            path="serverSettings/"
                            element={<ServerSettingsPanel />}
                        />

                        <Route
                            path="portalResource/"
                            element={<PortalResourceListPage />}
                        />
                        <Route
                            path="portalResource/edit/:portalResourceId"
                            element={<PortalResourceEditPage />}
                        />
                        <Route
                            path="portalResource/create"
                            element={<PortalResourceCreatePage />}
                        />

                        <Route path="author/" element={<AuthorListPage />} />
                        <Route
                            path="author/edit/:authorId"
                            element={<AuthorEditPage />}
                        />
                        <Route
                            path="author/create"
                            element={<AuthorCreatePage />}
                        />

                        <Route
                            path="resourceType/"
                            element={<ResourceTypeListPage />}
                        />
                        <Route
                            path="resourceType/edit/:resourceTypeId"
                            element={<ResourceTypeEditPage />}
                        />
                        <Route
                            path="resourceType/create"
                            element={<ResourceTypeCreatePage />}
                        />

                        <Route
                            path="subjectMatterCategory/"
                            element={<SubjectMatterCategoryListPage />}
                        />
                        <Route
                            path="subjectMatterCategory/edit/:subjectMatterCategoryId"
                            element={<SubjectMatterCategoryEditPage />}
                        />
                        <Route
                            path="subjectMatterCategory/create"
                            element={<SubjectMatterCategoryCreatePage />}
                        />

                        <Route
                            path="mediaUsageGoal/"
                            element={<MediaUsageGoalListPage />}
                        />
                        <Route
                            path="mediaUsageGoal/edit/:mediaUsageGoalId"
                            element={<MediaUsageGoalEditPage />}
                        />
                        <Route
                            path="mediaUsageGoal/create"
                            element={<MediaUsageGoalCreatePage />}
                        />

                        <Route
                            path="schoolType/"
                            element={<SchoolTypeListPage />}
                        />
                        <Route
                            path="schoolType/edit/:schoolTypeId"
                            element={<SchoolTypeEditPage />}
                        />
                        <Route
                            path="schoolType/create"
                            element={<SchoolTypeCreatePage />}
                        />

                        <Route path="faqAdmin/" element={<FAQItemListPage />} />
                        <Route
                            path="faqAdmin/edit/:faqItemId"
                            element={<FAQItemEditPage />}
                        />
                        <Route
                            path="faqAdmin/create"
                            element={<FAQItemCreatePage />}
                        />

                        <Route
                            path="impressum/"
                            element={<ImpressumDesktop />}
                        />
                        <Route
                            path="datenschutz/"
                            element={<DatenschutzerklaerungDesktop />}
                        />
                    </Route>,
                ),
            );
        }

        return (
            <>
                <Suspense
                    fallback={<div className="container">Loading...</div>}
                >
                    {!loginStore.isLoggedIn ? null : (
                        <div
                            className="homepage-desktop"
                            style={{
                                backgroundColor: '#d5f2ff',
                                fontSize: '1.5em',
                            }}
                        >
                            <a
                                style={{
                                    color: '#473db5',
                                    marginTop: '5px',
                                    marginLeft: '5px',
                                }}
                                href="/admin"
                            >
                                Admin Home
                            </a>
                        </div>
                    )}

                    <RouterProvider router={router} />
                </Suspense>
            </>
        );
    }
};

export default TuecedeTransferPortalApp;
